import {
  TableColumns,
  TableFilterTab,
} from '../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../../core/common/models/action-list.model';

export const SINGLE_VARIABLE_LIST_COLUMNS: TableColumns[] = [
  { header: '' },
  {
    header: 'variables_screen_variable_header_title',
    showViewIcon: true,
  },
  {
    header: 'variables_screen_all_values_header_title',
  },
  {
    header: 'variables_screen_active_values_header_title',
  },
  { header: '' },
];

export const SINGLE_VARIABLE_LIST_COLUMNS_SORT: TableColumns[] = [
  { header: '' },
  {
    header: 'variables_screen_variable_header_title',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'variables_screen_all_values_header_title',
    isSortable: true,
    sortKey: 'total_options_count][type',
  },
  {
    header: 'variables_screen_active_values_header_title',
    isSortable: true,
    sortKey: 'active_options_count][type',
  },
  { header: '' },
];

export const SINGLE_VARIABLE_LIST_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const SINGLE_VARIABLE_LIST_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
];
